/**
 * AWARE Health — LoadingSpinner Component
 * Minimal branded loading indicator.
 */

interface LoadingSpinnerProps {
  label?: string
  size?: 'sm' | 'md' | 'lg'
}

export default function LoadingSpinner({ label = 'Loading...', size = 'md' }: LoadingSpinnerProps) {
  const dim = { sm: 16, md: 24, lg: 36 }[size]
  const borderWidth = { sm: 2, md: 2, lg: 3 }[size]

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        color: '#475569',
      }}
    >
      <div
        style={{
          width: dim,
          height: dim,
          border: `${borderWidth}px solid rgba(20,184,166,0.2)`,
          borderTopColor: '#14b8a6',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }}
      />
      {label && (
        <span style={{ fontSize: 12, color: '#475569', letterSpacing: '0.04em' }}>{label}</span>
      )}
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  )
}
